import { useCallback, useMemo, useState } from 'react';
import { appendVariant } from '../../common/chat/composer/chatAssetUtils';
import { buildImageGroupDisplayMessages } from '../../common/chat/composer/chatImageGroupUtils';
import {
  MESSAGE_IMAGE_PATH,
  buildAssetUrl,
} from './artistGroupChatPaneUtils';

export default function useArtistGroupChatImages(messages) {
  const [imgModalOpen, setImgModalOpen] = useState(false);
  const [imgModalIndex, setImgModalIndex] = useState(0);

  const imageItems = useMemo(
    () =>
      messages
        .filter((message) => message?.message_format === 'image' && message?.image_file_name)
        .map((message) => ({
          ...message,
          messageId: message.id,
          src: appendVariant(buildAssetUrl(MESSAGE_IMAGE_PATH, message.image_file_name), 'proxy'),
          fullSrc: appendVariant(buildAssetUrl(MESSAGE_IMAGE_PATH, message.image_file_name), 'raw'),
          downloadUrl: appendVariant(buildAssetUrl(MESSAGE_IMAGE_PATH, message.image_file_name), 'raw'),
          fileName: message.image_file_name,
        })),
    [messages]
  );

  const displayMessages = useMemo(
    () => buildImageGroupDisplayMessages(messages),
    [messages],
  );

  const openImageModal = useCallback(
    (messageOrItem) => {
      const messageId = typeof messageOrItem === 'object'
        ? (messageOrItem?.messageId || messageOrItem?.message_id || messageOrItem?.id)
        : messageOrItem;
      const index = imageItems.findIndex((item) => String(item.messageId) === String(messageId));
      if (index < 0) return;
      setImgModalIndex(index);
      setImgModalOpen(true);
    },
    [imageItems]
  );

  const closeImageModal = useCallback(() => {
    setImgModalOpen(false);
  }, []);

  const showPrevImage = useCallback(() => {
    if (!imageItems.length) return;
    setImgModalIndex((current) => (current - 1 + imageItems.length) % imageItems.length);
  }, [imageItems.length]);

  const showNextImage = useCallback(() => {
    if (!imageItems.length) return;
    setImgModalIndex((current) => (current + 1) % imageItems.length);
  }, [imageItems.length]);

  const resetImageModal = useCallback(() => {
    setImgModalOpen(false);
    setImgModalIndex(0);
  }, []);

  return {
    closeImageModal,
    displayMessages,
    imageItems,
    imgModalIndex,
    imgModalOpen,
    openImageModal,
    resetImageModal,
    showNextImage,
    showPrevImage,
  };
}
